import React, { memo, useEffect, useState } from "react";
import "./CheckoutProduct.css";
import {
  getOptimizedUrl,
  getPrice,
} from "../../../../constants/globalFunction";
import { RUPEE } from "../../../../constants/globalConstants";

const CheckoutProduct = ({ item }) => {
  const { image, size } = item;
  const [price, setPrice] = useState(0);
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    if (item) {
      const fetchPrice = async () => {
        const p = await getPrice(item?.size);
        setPrice(p || 0);
        setAmount(p * item?.qty);
      };
      fetchPrice();
    }
  }, [item]);

  return (
    <div className="checkout-product-container">
      <div className="checkout-product-row">
        <div className="checkout-product-image">
          <img
            src={getOptimizedUrl(image?.image)}
            alt={item?.name}
            className="checkout-small-product-image"
            loading="lazy"
          />
        </div>
        <div className="checkout-product-details">
          <h4 className="product-name" title={item?.name}>
            {item?.name}
          </h4>
          <p className="detail-text" title={`Size: ${size?.size}`}>
            Size: {size?.size}
          </p>
          <p className="detail-text" title={item?.color?.name}>
            {item?.color?.name}
          </p>
          <div className="price-row">
            <span className="price" title={`${item?.qty} x ${RUPEE}${price}`}>
              {item?.qty} x {RUPEE}
              {price}
            </span>
            <span className="amount-text">
              Amount: {RUPEE}
              {amount}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(CheckoutProduct);
